/* global femcare, jwplayer */

/**
 * Modal Video Functions
 * Handles modal video player initialization and controls
 */

/**
 * Initialize modal video triggers
 */
femcare.video.initModalTriggers = function () {
    this.$modalPlayTriggers.each((index, trigger) => {
        $(trigger).on('click', (event) => {
            event.preventDefault();
            this.openVideoModal($(trigger));
        });
    });
};

/**
 * Open video in modal
 */
femcare.video.openVideoModal = function ($trigger) {
    const $videoModal = $('.modal--video');
    const playerId = `jwplayer-modal-${Date.now()}`;

    const $videoPlayer = $('<div class="video-player"></div>');
    $videoPlayer.attr('id', playerId);

    const container = $videoModal.find('.video-player-parent');
    container.empty().append($videoPlayer);

    const videoConfig = this.buildVideoConfigFromTrigger($trigger);

    setTimeout(() => {
        if ($videoModal.hasClass('displayed')) {
            this.checkJWPlayer().then(() => {
                const player = jwplayer(playerId).setup(videoConfig);

                player.__isModal = true;

                this.setupVideoEvents(player, $trigger, container, playerId);
                this.activePlayers.push(player);
                player.play();
            });
        }
    }, 50);

    this.bindModalCloseEvents($videoModal);
};

/**
 * Build video config from modal trigger
 */
femcare.video.buildVideoConfigFromTrigger = function ($trigger) {
    const sources = [];
    const hlsUrl = $trigger.attr('data-video-url-hls');
    const progressiveUrl = $trigger.attr('data-video-url-progressive');

    if (hlsUrl) {
        sources.push({ file: hlsUrl, type: 'hls' });
    }
    if (progressiveUrl) {
        sources.push({ file: progressiveUrl, type: 'mp4' });
    }

    return {
        file: sources[0]?.file,
        sources: sources,
        image: $trigger.attr('data-video-image'),
        title: $trigger.attr('data-video-name'),
        aspectratio: $trigger.attr('data-video-aspect-ratio') || '16:9',
        width: '100%',
        height: 'auto',
        controls: $trigger.attr('data-video-controls') !== 'false',
        mute: $trigger.attr('data-video-mute') === 'true',
        autostart: false,
        autoPause: { viewability: true },
        repeat: $trigger.attr('data-video-repeat') === 'true',
        sharing: false,
        analytics: { enabled: true, cookies: false }
    };
};

/**
 * Bind modal close events
 */
femcare.video.bindModalCloseEvents = function ($videoModal) {
    // Handle explicit close buttons
    $videoModal.find('[data-dismiss="modal"]').off('click.video').on('click.video', () => {
        this.pauseAllVideos();
        this.cleanupModalVideos();
    });

    // Handle backdrop click or modal dialog click (outside video)
    $videoModal.off('click.backdrop').on('click.backdrop', (event) => {
        const modalDialog = $videoModal.find('.modal__dialog')[0];
        if (event.target === $videoModal[0] || event.target === modalDialog) {
            this.pauseAllVideos();
            this.cleanupModalVideos();
        }
    });
};
